var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisitMariborLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.819,
    height: 26.41,
    viewBox: "0 0 52.819 26.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M507.379,193.34a2.174,2.174,0,0,1-1.62,0h-.009v4.912h1.643V193.34Z",
    transform: "translate(-479.037 -183.128)",
    fill: "#e7343f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M0,0V23.156a3.006,3.006,0,0,0,3.243,3.237A14.313,14.313,0,0,0,7,25.579,61.551,61.551,0,0,1,26.41,22.905a61.264,61.264,0,0,1,19.4,2.686,14.249,14.249,0,0,0,3.761.818,3.006,3.006,0,0,0,3.243-3.237L52.819,0ZM51.35,23.173a1.558,1.558,0,0,1-1.776,1.769,13.61,13.61,0,0,1-3.341-.756c-3.446-1.028-9.213-2.747-19.824-2.747A62.88,62.88,0,0,0,6.586,24.174a13.681,13.681,0,0,1-3.343.753,1.559,1.559,0,0,1-1.776-1.769V1.467H51.352Z",
    fill: "#e7343f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M142.57,159.589l-2.453-3.679H138.85V162.8h1.713l-.01-3.476,1.541,2.382v.01h.952v-.01l1.531-2.362V162.8h1.713V155.91h-1.277Z",
    transform: "translate(-131.516 -147.675)",
    fill: "#e7343f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M300.791,191.6a2.451,2.451,0,0,0-1.348-.375,2.567,2.567,0,0,0,0,5.128,2.451,2.451,0,0,0,1.348-.375v.274h1.642v-4.915h-1.641Zm0,2.949a1.263,1.263,0,0,1-1.024.456,1.222,1.222,0,0,1,0-2.441,1.274,1.274,0,0,1,1.024.466Z",
    transform: "translate(-281.313 -181.122)",
    fill: "#e7343f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M423.182,191.881H421.54V196.8h1.642v-2.808a2.337,2.337,0,0,1,1.69-.628V191.8a2.448,2.448,0,0,0-1.69.608Z",
    transform: "translate(-399.275 -181.669)",
    fill: "#e7343f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M504.033,147.27a.928.928,0,1,0,.963.932A.931.931,0,0,0,504.033,147.27Z",
    transform: "translate(-476.498 -139.491)",
    fill: "#e7343f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M565.85,152.349a2.455,2.455,0,0,0-1.348.374V150.16H562.86v7.2H564.5V157.1a2.456,2.456,0,0,0,1.348.375,2.567,2.567,0,0,0,0-5.128Zm-.324,3.78a1.262,1.262,0,0,1-1.024-.456v-1.52a1.274,1.274,0,0,1,1.024-.466,1.223,1.223,0,0,1,0,2.443Z",
    transform: "translate(-533.13 -142.229)",
    fill: "#e7343f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M799.643,192.408v-.528H798V196.8h1.643v-2.808a2.338,2.338,0,0,1,1.69-.628V191.8A2.459,2.459,0,0,0,799.643,192.408Z",
    transform: "translate(-755.85 -181.669)",
    fill: "#e7343f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M683.591,196.768a2.664,2.664,0,0,0,2.327-2.641c0-.079,0-.158-.012-.233a2.674,2.674,0,0,0-5.316.28v0a2.663,2.663,0,0,0,2.281,2.585,3.124,3.124,0,0,0,.384.026A3.024,3.024,0,0,0,683.591,196.768Zm-1.44-2.584a1.111,1.111,0,1,1,2.219,0,1.112,1.112,0,1,1-2.219,0Z",
    transform: "translate(-644.642 -181.489)",
    fill: "#e7343f"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M667.633,277.67l-.973,1.391,1.346.942.972-1.389A3.159,3.159,0,0,1,667.633,277.67Z",
    transform: "translate(-631.447 -263.004)",
    fill: "#e7343f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitMariborLogo);
export default __webpack_public_path__ + "static/media/visit-maribor-logo.6737fd1ae9c505c683fd70ed365b18c1.svg";
export { ForwardRef as ReactComponent };